/**
 * Route guard. `RequireRole` gates a role's surface: signed-out users go to that role's
 * sign-in page, other roles to their own home (client-side UX only — the backend RBAC
 * middleware is the real gate).
 */

import { Navigate } from "react-router-dom";
import type { ReactNode } from "react";

import { roleHome, roleLogin, useAuth } from "./AuthContext";
import type { Role } from "./AuthContext";

export function Loading() {
  return (
    <div className="min-h-dvh flex items-center justify-center text-gray-400">
      Loading…
    </div>
  );
}

export function RequireRole({
  role,
  children,
}: {
  role: Role;
  children: ReactNode;
}) {
  const { user, bootstrapping } = useAuth();
  if (bootstrapping) return <Loading />;
  // Signed out → the guarded role's own sign-in page (/patient, /doctor, /pharmacist, or "/").
  if (!user) return <Navigate to={roleLogin(role)} replace />;
  if (user.role !== role) return <Navigate to={roleHome(user.role)} replace />;
  return <>{children}</>;
}
